import { Component} from '@angular/core';
import { AccessibilityService } from '../../services/accessibility.service';

@Component({
  selector: 'app-skiplink',
  templateUrl: './skiplink.component.html'
})
export class SkiplinkComponent {

  public skiplinkId: any;
  constructor(private accessibilityService: AccessibilityService) { }

  skipToContent() {
    this.skiplinkId = this.accessibilityService.getSkipLinkId();
    if (this.skiplinkId) {
      this.accessibilityService.focus('#' + this.skiplinkId);
    } else {
      this.accessibilityService.focus('#landing-connect');
    }
  }

}
